var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedaccounts = function SvgLinkedaccounts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    strokeDasharray: "7,13",
    strokeLinecap: "square",
    d: "M.5-414.732v574.464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6 43.241h-.8V37.69a2.39 2.39 0 0 0-2.4-2.38h-1.6V20.241H36v15.07h-4.8V20.24h-4.8v15.07h-4.8V20.24h-4.8v15.07H12V20.24H7.2v15.07H5.6a2.39 2.39 0 0 0-2.4 2.379v5.551h-.8a2.39 2.39 0 0 0-2.4 2.38v1.586c0 .438.358.793.8.793h46.4c.442 0 .8-.355.8-.793V45.62a2.39 2.39 0 0 0-2.4-2.38zm-5.6 0H8V40.07h32v3.172zm7.227-32.015l-21.71-8.982a4.84 4.84 0 0 0-3.035 0L.773 11.226A1.19 1.19 0 0 0 0 12.338v2.748c0 .657.537 1.19 1.2 1.19h2v1.19c0 .657.537 1.19 1.2 1.19h39.2c.663 0 1.2-.533 1.2-1.19v-1.19h2c.663 0 1.2-.533 1.2-1.19v-2.748a1.19 1.19 0 0 0-.773-1.112zM4.8 13.896L24 6.76l19.2 7.138H4.8z"
  }))));
};
export default SvgLinkedaccounts;